import constants from 'constants/constants';
import { useQuery } from 'react-query';

import { getUserImage as queryFn } from 'api/endPoints/getUserImage';

export const useQueryGetUserImage = (params) => {
    return useQuery<string | null, QueryError>(['getUserImage', params], () => queryFn(params), {
        enabled: Boolean(params.email) && !params.isUnassigned && Boolean(params.imageName !== ''),
        staleTime: constants.MINUTE * 5,
    });
};
